import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate, Redirect, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import swal from "sweetalert";
import { login } from "../../Redux/Action/LoginAction/loginAction";
import { useDispatch, useSelector } from "react-redux";
import { setItemLocalStorage } from "../../Utils/localStroge";
import {
  ANDROID_APP_LINK,
  BUSINESS_TYPE_SIGN_IN,
  CUSTOMER_TYPE_SIGN_IN,
  IOS_APP_LINK,
  SIGN_UP_TYPE,
} from "../../Utils/constants";
import EyesOnIcon from "../../assets/images/show.png";
import EyesOffIcon from "../../assets/images/hide.png";
import Select from "react-select";
import countryList from "react-select-country-list";

import "./login.css";
import ValidatedPhoneInput from "../../Component/ValidatedPhoneInput";
import {
  facebookRegisterUpdate,
  googleRegisterUpdate,
  phoneRegisterUpdate,
  registerApi,
} from "../../API/ApiService";
import { handleUuidAfterLogin } from "../../Utils/uuidHandler";
import { loadingAction } from "../../Redux/Action/loadingAction";
import {
  isPhoneValid,
  validatePhoneComprehensive,
} from "../../Utils/helperFunction";

function Register() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [currentCountry, setCurrentCountry] = useState(null);

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    password: "",
    cpassword: "",
    phone: "",
    zipcode: "",
  });
  const [touched, setTouched] = useState({
    name: false,
    email: false,
    password: false,
    cpassword: false,
    phone: false,
    zipcode: false,
  });

  const socialLoginOptions = [
    SIGN_UP_TYPE.GOOGLE,
    SIGN_UP_TYPE.APPLE,
    SIGN_UP_TYPE.FACEBOOK,
  ];

  const { loginDataSuccess } = useSelector((state) => state.LoginData);
  const isLoggedIn = loginDataSuccess?.access_token && loginDataSuccess?.result;
  const loginData = loginDataSuccess?.result;
  const signUpType = loginDataSuccess?.result?.signup_type;
  const isSocialLogin = isLoggedIn && socialLoginOptions.includes(signUpType);

  const disableEmail = isSocialLogin || signUpType === SIGN_UP_TYPE.REGULAR;
  const disableName = isSocialLogin || signUpType === SIGN_UP_TYPE.REGULAR;
  const disablePhone =
    signUpType === SIGN_UP_TYPE.PHONE || signUpType === SIGN_UP_TYPE.REGULAR;

  const [values, setValues] = useState({
    role_id: 3,
    name: "",
    email: "",
    password: "",
    cpassword: "",
    country_code: "",
    phone: "",
    dob: "01/01/1990",
    zipcode: "",
  });
  const location = useLocation();
  const [value, setValue] = useState("");
  const options = useMemo(() => countryList().getData(), []);
  const [checkedVal, setCheckedVal] = useState("Customer");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    // console.log(location);

    if (location?.state?.checkedVal) {
      setCheckedVal(location.state.checkedVal);
      setValues({
        ...values,
        role_id: location?.state?.checkedVal === CUSTOMER_TYPE_SIGN_IN ? 3 : 2,
      });
    }
  }, [location]);

  useEffect(() => {
    if (loginData && loginData.role_id) {
      setValues({
        role_id: loginData.role_id,
        name: loginData?.userProfile?.name || "",
        email: loginData?.email_id || "",
        password: "",
        cpassword: "",
        country_code: loginData?.country_code || "",
        phone: loginData?.phone || "",
        dob: "01/01/1990",
        zipcode: "",
      });

      setCheckedVal(
        loginData.role_id == 3 ? CUSTOMER_TYPE_SIGN_IN : BUSINESS_TYPE_SIGN_IN
      );

      if (loginData?.phone?.length > 1) {
        const phoneString = `${loginData?.country_code || ""}${loginData.phone
          }`;
        setPhone(phoneString);
      }
      if (loginData?.country_code?.length > 1) {
        setCountryCode(loginData.country_code);
      }
    }
  }, [loginData]);

  const changeHandler = (value) => {
    setValue(value);
  };

  // console.log(values, loginData, "REGISTER");

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "name":
        const nameRegwx = /^[A-Za-z ]+$/;
        if (!value.trim()) {
          error = "Name is required";
        } else if (!nameRegwx.test(value)) {
          error = "Please enter valid name, only alphabets";
        }
        break;
      case "email":
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value.trim()) {
          error = "Email is required";
        } else if (!emailRegex.test(value)) {
          error = "Please enter a valid email address";
        }
        break;
      case "password":
        if (!value) {
          error = "Password is required";
        } else if (value.length < 8) {
          error =
            "Password must be at least 8 characters with mix of letters, numbers & symbols";
        } else {
          const hasLetter = /[a-zA-Z]/.test(value);
          const hasSmallLetter = /[a-z]/.test(value);
          const hasCapitalLetter = /[A-Z]/.test(value);
          const hasNumber = /\d/.test(value);
          const hasSymbol = /[!@#$%&*]/.test(value);

          if (!hasLetter && !hasNumber && !hasSymbol) {
            error =
              "Password must be at least 8 characters with mix of letters, numbers & symbols";
          } else if (!hasSmallLetter) {
            error =
              "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length";
          } else if (!hasCapitalLetter) {
            error =
              "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length";
          } else if (!hasNumber) {
            error =
              "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length";
          } else if (!hasSymbol) {
            error =
              "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length";
          }
        }
        break;
      case "cpassword":
        if (!value) {
          error = "Please confirm your password";
        } else if (value !== values.password) {
          error = "Passwords do not match";
        }
        break;
      case "phone":
        if (!value) {
          error = "Phone number is required";
        } else if (currentCountry?.iso2?.toUpperCase() === 'JM') {
          // Special validation for Jamaica - just check if we have 7 digits
          const jamaicaNumber = phone.replace(/\D/g, '');
          const extractedNumber = jamaicaNumber.replace(/^1876|^876/, '');
          if (extractedNumber.length !== 7) {
            error = "Jamaican phone numbers must be exactly 7 digits";
          }
        } else if (currentCountry && phone) {
          const validation = validatePhoneComprehensive(phone, currentCountry);
          if (!validation.isValid) {
            error = validation?.error || 'Phone number is invalid';
          }
        } else if (!isPhoneValid(phone)) {
          error = "Please input a valid international phone number";
        }
        break;

      case "zipcode":
        if (!value.trim()) {
          error = "Zip code is required";
        } else {
          const cleanZipcode = value.trim();

          const usZipRegex = /^\d{5}(-\d{4})?$/;

          const intlPostalRegex = /^[A-Za-z0-9\s-]{3,10}$/;

          if (cleanZipcode.length < 3) {
            error = "Zip code is too short";
          } else if (cleanZipcode.length > 10) {
            error = "Zip code is too long (maximum 10 characters)";
          } else if (
            !usZipRegex.test(cleanZipcode) &&
            !intlPostalRegex.test(cleanZipcode)
          ) {
            error = "Please enter a valid zip code";
          }
        }
        break;
      default:
        break;
    }

    return error;
  };

  const handlePhone = (phone, country, inputvalue) => {
    setPhone(phone);
    setCurrentCountry(country);

    const countryCode = country.iso2?.toUpperCase();

    // Special handling for Jamaica
    if (countryCode === 'JM') {
      // Jamaica uses +1876 but we need to split it correctly
      setCountryCode("+1876"); // Keep the full +1876 for display/storage

      // Extract the 7-digit phone number (after +1876)
      let phoneNumber = phone.replace(/^\+1876/, '').replace(/\D/g, '');

      // If the phone doesn't start with +1876, try other patterns
      if (!phone.startsWith('+1876')) {
        const cleanPhone = phone.replace(/\D/g, '');
        if (cleanPhone.startsWith('1876')) {
          phoneNumber = cleanPhone.substring(4);
        } else if (cleanPhone.startsWith('876')) {
          phoneNumber = cleanPhone.substring(3);
        } else if (cleanPhone.length === 7) {
          phoneNumber = cleanPhone;
        } else {
          phoneNumber = cleanPhone;
        }
      }

      setPhoneNumber(phoneNumber);
      setValues((prev) => ({
        ...prev,
        phone: phoneNumber,
        country_code: "+1876",
      }));

      // Clear any previous errors for Jamaica since we handle it specially
      if (touched.phone) {
        setErrors((prev) => ({ ...prev, phone: "" }));
      }

    } else {
      // Standard handling for other countries
      setCountryCode("+" + country?.dialCode);

      let mystring = phone.replace("+", "");
      mystring = mystring.replace(country?.dialCode, "");
      setPhoneNumber(mystring);
      setValues((prev) => ({
        ...prev,
        phone: mystring,
        country_code: "+" + country?.dialCode,
      }));

      // Validate phone number with country for non-Jamaica countries
      if (touched.phone) {
        if (!phone || !country) {
          setErrors((prev) => ({ ...prev, phone: "Phone number is required" }));
        } else {
          const validation = validatePhoneComprehensive(phone, country);
          setErrors((prev) => ({ ...prev, phone: validation.error || "" }));
        }
      }

      // Validate phone number with country
      if (touched.phone) {
        if (!phone || !country) {
          setErrors((prev) => ({ ...prev, phone: "Phone number is required" }));
        } else {
          const validation = validatePhoneComprehensive(phone, country);
          setErrors((prev) => ({ ...prev, phone: validation.error || "" }));
        }
      }
    }
  };
  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setValues({
      ...values,
      [name]: value,
    });

    if (touched[name]) {
      const error = validateField(name, value);
      setErrors({ ...errors, [name]: error });
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched({ ...touched, [name]: true });
    const error = validateField(name, value);
    setErrors({ ...errors, [name]: error });
  };

  const validateForm = () => {
    const formValues = { ...values };
    const newErrors = {};
    const newTouched = {};
    let isValid = true;

    Object.keys(touched).forEach((key) => {
      newTouched[key] = true;
    });

    Object.keys(newTouched).forEach((key) => {
      const error = validateField(key, formValues[key]);
      newErrors[key] = error;
      if (error) isValid = false;
    });

    setErrors(newErrors);
    setTouched(newTouched);

    return isValid;
  };

  // ======= submit Login request ==============
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!validateForm()) {
      return;
    }
    dispatch(loadingAction(true));

    const password = values.password;
    const hasSmallLetter = /[a-z]/.test(password);
    const hasCapitalLetter = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSymbol = /[!@#$%&*]/.test(password);

    if (
      password.length < 8 ||
      !(hasSmallLetter && hasNumber && hasSymbol & hasCapitalLetter)
    ) {
      setErrorMsg(
        "Password must contain a upper case letter, a lower case letter, a number and special characters(!@#$&%*) and at least 8 characters in length"
      );
      dispatch(loadingAction(false));
      return;
    }

    if (values.password !== values.cpassword) {
      setErrorMsg("Password and Confirm Password do not match!");
      dispatch(loadingAction(false));
      return;
    }

    let userData = {
      name: values?.name,
      email: values?.email,
      dob: "01/01/1990",
      zipcode: values?.zipcode,
      country_code: countryCode,
      password: values?.password,
    };

    if (!isLoggedIn || (isLoggedIn && signUpType !== SIGN_UP_TYPE.PHONE)) {
      userData = {
        ...userData,
        role_id: values.role_id,
        phone: values.phone,
        platform: "web",
        os_version: "0",
        app_version: "v.0.0",
        user_timezone: "GMT+5:30",
      };
    }
    console.log(userData, "userData")
    if (loginData?.registered_by_email === 1) {
      delete userData?.email;
    }
    let finalAPI = registerApi;

    if (isLoggedIn) {
      switch (loginData.signup_type) {
        case SIGN_UP_TYPE.GOOGLE:
          finalAPI = googleRegisterUpdate;
          break;
        case SIGN_UP_TYPE.FACEBOOK:
          finalAPI = facebookRegisterUpdate;
          break;
        case SIGN_UP_TYPE.PHONE:
          finalAPI = phoneRegisterUpdate;
          break;
        default:
          finalAPI = registerApi;
          break;
      }
    }
    try {
      const response = await finalAPI(userData);
      const loginDataSuccess = response;

      if (loginDataSuccess) {
        dispatch(loadingAction(false));

        if (loginDataSuccess?.data?.result?.is_deleted == 0) {
          if (loginDataSuccess?.data?.result?.user_state == "0") {
            setItemLocalStorage(
              "accessToken",
              loginDataSuccess.data.access_token
            );
            setItemLocalStorage(
              "refreshToken",
              loginDataSuccess.data.refresh_token
            );
            setItemLocalStorage(
              "user",
              JSON.stringify(loginDataSuccess.data.result)
            );
            setItemLocalStorage("sign_in_type", checkedVal);
          }
        } else {
          swal({
            title: "Inactive User!",
            text: "User is either Inactive or Deleted",
            buttons: false,
            icon: "error",
            timer: 3000,
          });
        }
        if (isLoggedIn) {
          swal({
            title: "Profile Updated successfully!",
            text: "Your Profile has been updated successfully",
            buttons: false,
            icon: "success",
            timer: 3000,
          }).then(() => {
            if (
              checkedVal === BUSINESS_TYPE_SIGN_IN &&
              (loginDataSuccess?.data?.result.user_state === "1" ||
                loginDataSuccess?.data?.result.user_state === "2")
            ) {
              navigate("/adbusinessdetails");
            } else {
              navigate(location?.state?.backRoute || "/");
            }
          });
        } else {
          swal({
            title: "Registration successfull!",
            text: "Registration Successfull now verify OTP send to your account",
            buttons: false,
            icon: "success",
            timer: 3000,
          }).then(() => {
            navigate("/signinotp", { state: { forget_password: 0 } });
          });
        }
      } else {
        dispatch(loadingAction(false));

        swal({
          title: "Registration Failed",
          text: loginDataSuccess?.data?.message,
          buttons: false,
          icon: "error",
          timer: 3000,
        });
      }
    } catch (err) {
      dispatch(loadingAction(false));
    }
  };

  const togglePasswordVisibility = (val) => {
    if (val === "password") {
      setShowPassword(!showPassword);
    } else {
      setShowPassword2(!showPassword2);
    }
  };

  const checkHandler = (event) => {
    const value = event.target.value;
    setCheckedVal(value);

    setValues({
      ...values,
      role_id: value === CUSTOMER_TYPE_SIGN_IN ? 3 : 2,
    });
  };
  return (
    <>
      <div className="container login2 ">
        <div className="row login3">
          <div className="col-md-6 trust_sec">
            <h1>
              Your Trusted
              <br />
              Local Connection
              <br />{" "}
              <label
                style={{
                  color: "#349c52",
                  position: "relative",
                }}
              >
                Starts Here
                <img
                  src="images/green-suf.png"
                  className="key_feature_designg2"
                  alt=""
                  style={{ left: "3px" }}
                />
              </label>
            </h1>
            <div id="download_app">
              <div className="container login_download_app mt-1">
                <h6>
                  <img
                    src="images/suffixes3.svg"
                    className="suffixes3"
                    alt=""
                  />
                  Please Download and Install Brigiz App
                  <br />
                  to Explore More features{" "}
                  <img
                    src="images/green-suf2.png"
                    className="green-suf2"
                    style={{
                      width: "141px",
                      height: "32px",
                      marginLeft: "-136px",
                    }}
                    alt=""
                  />
                </h6>
              </div>
              <div className=" exp-download-btns mt-4">
                <button
                  onClick={() => window.open(ANDROID_APP_LINK, "_")}
                  style={{ background: "#292828" }}
                >
                  <div className="g_pay_container ">
                    <div className=" btn-img1">
                      <img src="images/play-button.svg" alt="" />
                    </div>
                    <div className=" btn-txt1">
                      <span>GET IT ON</span>
                      <p className="text-white m-0">Google Play</p>
                    </div>
                  </div>
                </button>
                <button
                  onClick={() => window.open(IOS_APP_LINK, "_")}
                  style={{ width: "180px", background: "#292828" }}
                >
                  <div className="g_pay_container">
                    <div className=" btn-img1">
                      <img src="images/apple.svg" />
                    </div>
                    <div className="col-md-9 btn-txt1">
                      <span>Download on the</span>
                      <p className="text-white m-0">App Store</p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-6 form_screen" id="signup_screen_1">
            <div className="login_card bg-white p-4 mt-1 mb-5">
              <div className="login_back_btn">
                {" "}
                <h4 className="login_form_label_2">
                  {isLoggedIn && loginData
                    ? "Lets Get Started"
                    : "Create an Account!"}
                </h4>
                <button
                  href="#"
                  style={{ verticalAlign: "text-bottom" }}
                  onClick={() => navigate(-1)}
                >
                  <img src="/images/back.png" alt="" /> Back
                </button>
              </div>
              <form onSubmit={handleSubmit} className="login_form2">
                {!loginData && (
                  <div className="d-flex justify-content-evenly align-items-center mobile-radio-wrap mt-4 ">
                    <div className=" col-md-6 d-flex  align-items-center flex-nowrap justify-content-start">
                      <input
                        type="radio"
                        className="form-check-input m-0"
                        id="radio1"
                        name="role_id"
                        value={CUSTOMER_TYPE_SIGN_IN}
                        onChange={(e) => {
                          handleInputChange(e);
                          checkHandler(e);
                        }}
                        checked={checkedVal === CUSTOMER_TYPE_SIGN_IN}
                      />
                      <label
                        className="form-check-label2 text-nowrap"
                        htmlFor="radio1"
                      >
                        For Customer
                      </label>
                    </div>
                    <div
                      style={{ paddingLeft: "0px" }}
                      className="form-check  pl-0 col-md-6 d-flex  align-items-center flex-nowrap justify-content-start"
                    >
                      <input
                        type="radio"
                        className="form-check-input m-0 pl-0"
                        id="radio2"
                        name="role_id"
                        value={BUSINESS_TYPE_SIGN_IN}
                        // onChange={checkHandler}
                        onChange={(e) => {
                          handleInputChange(e);
                          checkHandler(e);
                        }}
                        checked={checkedVal === BUSINESS_TYPE_SIGN_IN}
                      />

                      <label
                        className="form-check-label2 text-nowrap"
                        htmlFor="radio2"
                      >
                        For Business
                      </label>
                    </div>
                  </div>
                )}

                <label className="login_form_email2 mt-4 mb-2">Full Name</label>
                <input
                  className="login_form_input2"
                  type="text"
                  name="name"
                  value={values.name}
                  disabled={disableName}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                />
                {touched.name && errors.name && (
                  <div className="text-danger small mt-1">{errors.name}</div>
                )}

                <label className="login_form_email2 my-2">Email Address</label>
                <input
                  className="login_form_input2"
                  type="text"
                  disabled={disableEmail}
                  name="email"
                  value={values.email}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                />
                {touched.email && errors.email && (
                  <div className="text-danger small mt-1">{errors.email}</div>
                )}
                <div className="register-form-city-wrap">
                  <div style={{ width: "50%" }}>
                    <>
                      <label className="login_form_email2 my-2">
                        Mobile Number
                      </label>
                      <ValidatedPhoneInput
                        defaultCountry="us"
                        value={phone}
                        disabled={disablePhone}
                        onChange={(phone, { country, inputValue }) => {
                          handlePhone(phone, country, inputValue);
                        }}
                        onValidationChange={(validation) => {
                          if (touched.phone) {
                            setErrors((prev) => ({
                              ...prev,
                              phone: validation.error || "",
                            }));
                          }
                        }}
                        showValidation={touched.phone}
                        onBlur={(e) => {
                          setTouched((prev) => ({ ...prev, phone: true }))
                        }}
                        name="phone"
                      />
                    </>
                  </div>
                  <div style={{ width: "50%" }}>
                    <label className="login_form_email2 my-2">Zip Code</label>
                    <input
                      className="login_form_input2"
                      type="text"
                      name="zipcode"
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                    />
                    {touched.zipcode && errors.zipcode ? (
                      <div className="text-danger small mt-1">
                        {errors.zipcode}
                      </div>
                    ) : (
                      <div style={{ color: "#666666", fontSize: "12px" }}>
                        Note: If your country does not use zip codes, please
                        enter "Zipcode" as a placeholder to proceed.
                      </div>
                    )}
                  </div>
                </div>
                <label className="login_form_email2 my-2">Password</label>
                <div className="password-input-container">
                  <input
                    className="login_form_input2 mb-1"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn bg-transparent"
                    onClick={() => togglePasswordVisibility("password")}
                  >
                    {showPassword ? (
                      <img src={EyesOnIcon} className="eyes-icon" alt="" />
                    ) : (
                      <img src={EyesOffIcon} className="eyes-icon" alt="" />
                    )}
                  </button>
                </div>
                {touched.password && errors.password ? (
                  <div className="text-danger small mt-1">
                    {errors.password}
                  </div>
                ) : (
                  <div className="password_warning_text  mb-2">
                    Password must contain a upper case letter, a lower case
                    letter, a number and special characters(!@#$&%*) and at
                    least 8 characters in length
                  </div>
                )}

                <label className="login_form_email2 mt-3 mb-2">
                  Confirm Password
                </label>
                <div className="password-input-container">
                  <input
                    className="login_form_input2"
                    type={showPassword2 ? "text" : "password"}
                    name="cpassword"
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn bg-transparent"
                    onClick={() => togglePasswordVisibility("cpassword")}
                  >
                    {showPassword2 ? (
                      <img src={EyesOnIcon} className="eyes-icon" alt="" />
                    ) : (
                      <img src={EyesOffIcon} className="eyes-icon" alt="" />
                    )}
                  </button>
                </div>
                {touched.cpassword && errors.cpassword && (
                  <div className="text-danger small mt-1">
                    {errors.cpassword}
                  </div>
                )}

                <button className="login_form_btn mt-4" disabled={!checkedVal}>
                  {isLoggedIn ? "Update" : "Sign Up"}
                </button>
                {!isLoggedIn && (
                  <div className="signup_text text-center mt-3">
                    Already have an account?{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() =>
                        navigate("/login", { state: { checkedVal } })
                      }
                    >
                      Sign In
                    </span>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
        <div id="mobile_view">
          <div className="container login_download_app mt-1">
            <h6>
              <img src="images/suffixes3.svg" className="suffixes3" alt="" />
              Please Download and Install Brigiz App
              <br />
              to Explore More features{" "}
              <img
                src="images/green-suf2.png"
                className="green-suf2"
                style={{
                  width: "168px",
                  height: "32px",
                  marginLeft: "-158px",
                }}
                alt=""
              />
            </h6>
          </div>
          <div className=" exp-download-btns mt-4">
            <button
              onClick={() => window.open(ANDROID_APP_LINK, "_")}
              style={{ background: "#292828" }}
            >
              <div className="g_pay_container ">
                <div className=" btn-img1">
                  <img src="images/play-button.svg" alt="" />
                </div>
                <div className=" btn-txt1">
                  <span>GET IT ON</span>
                  <p className="text-white m-0">Google Play</p>
                </div>
              </div>
            </button>
            <button
              onClick={() => window.open(IOS_APP_LINK, "_")}
              style={{ width: "180px", background: "#292828" }}
            >
              <div className="g_pay_container">
                <div className=" btn-img1">
                  <img src="images/apple.svg" />
                </div>
                <div className="col-md-9 btn-txt1">
                  <span>Download on the</span>
                  <p className="text-white m-0">App Store</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
